import React from 'react';

import {findFixedFilter, fixedFilters} from '../../utils/filter-utils';

import CheckBoxList from '../../../../../stories/components/hotels/common/CheckBoxList/CheckBoxList';

const PriceRangeFilter = ({updateFilter, priceRangeFilter}) => {
  const onFilterSelect = (item, itemUnderAction, isSelected) => {
    updateFilter({step_range: item.map(subItem => subItem.key)});
  };

  return (
    <CheckBoxList
      name="PRICE RANGE"
      data={fixedFilters.step_range.data}
      lookup={item => `${fixedFilters.step_range.name}${item.key.min}`}
      type={fixedFilters.step_range.type}
      renderItem={item => <>{item.name}</>}
      actionHandler={onFilterSelect}
      resetHandlerProp={() => {
        updateFilter({step_range: []});
      }}
      defaultState={
        (priceRangeFilter &&
          priceRangeFilter.map(item =>
            findFixedFilter({
              target: item,
              src: fixedFilters.step_range.data,
              type: fixedFilters.step_range.name,
            }),
          )) ||
        []
      }
    />
  );
};

export default React.memo(PriceRangeFilter);
